export default ({
  name,
  sku,
  brand,
  category,
  priceCurrency,
  price,
  image,
}) => ({
  '@context': 'http://schema.org',
  '@type': 'Product',
  name,
  sku,
  category,
  image,
  brand: {
    '@type': 'Thing',
    name: brand,
  },
  offers: {
    '@type': 'Offer',
    priceCurrency,
    price,
  },
})
